import type { ReactNode } from "react";
import { Modal as RNModal, Pressable, ScrollView, Text, View } from "react-native";

export function Modal({
  visible,
  onClose,
  title,
  children,
  theme = "light",
  maxWidth,
}: {
  visible: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  theme?: "light" | "dark";
  maxWidth?: number;
}) {
  const overlay = theme === "dark" ? "bg-black/90" : "bg-forest/90";
  const box = theme === "dark" ? "bg-off-black border-amber/20 shadow-modal-dark" : "bg-linen border-amber/20 shadow-modal-light";
  const head = theme === "dark" ? "bg-amber/5 border-amber/15" : "bg-forest-mid border-amber/15";
  return (
    <RNModal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <Pressable className={`flex-1 items-center justify-center px-4 ${overlay}`} onPress={onClose}>
        <Pressable
          className={`w-full rounded-modal border ${box}`}
          style={{ maxWidth: maxWidth ?? 460 }}
          onPress={(e) => e.stopPropagation()}
        >
          <View className={`border-b px-6 py-5 ${head}`}>
            {title ? <Text className={`text-lg font-semibold ${theme === "dark" ? "text-white" : "text-linen"}`}>{title}</Text> : null}
            <Pressable className="absolute right-4 top-4 h-8 w-8 items-center justify-center rounded-full border border-white/25 bg-white/10" onPress={onClose}>
              <Text className="text-white/80">×</Text>
            </Pressable>
          </View>
          <ScrollView className="max-h-[500px] p-5">{children}</ScrollView>
        </Pressable>
      </Pressable>
    </RNModal>
  );
}
